module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-91.be4be2ed.jpg";